module.exports = __webpack_public_path__ + "static/buildinglookup-62562c739dbd60c19929a661126e923b.jpg";